import {
	GET_VIEWER_ALL_DOCUMENTS_REQUEST,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET,
	UPDATE_VIEWER_PAGE_NUMBER,
	GET_AUDIT_HISTORY,
	GET_AUDIT_HISTORY_SUCCESS,
	GET_AUDIT_HISTORY_FAILED,
	GET_ANNOTATION_SUCCESS,
	GET_ANNOTATION_FAILED,
	GET_ANNOTATION,
	ADD_ANNOTATION,
	ADD_ANNOTATION_SUCCESS,
	ADD_ANNOTATION_FAILED,
	DELETE_ANNOTATION,
	DELETE_ANNOTATION_SUCCESS,
	UPDATE_SKIP_COUNT,
	LOG_AUDIT,
	ZOOM_IN_IMAGE,
	ZOOM_OUT_IMAGE,
	GET_CHAT,
	GET_CHAT_SUCCESS,
	GET_CHAT_FAILED,
	GET_CHAT_RESET,
	POST_CHAT,
	POST_CHAT_SUCCESS,
	POST_CHAT_FAILED,
	UPDATE_CURRENT_SESSION,
	ROTATE_LEFT_IMAGE,
	ROTATE_RIGHT_IMAGE,
} from "../types"

export const getViewerAllDocumentsRequest = (data) => ({
	type: GET_VIEWER_ALL_DOCUMENTS_REQUEST,
	payload: data,
})

export const getViewerAllDocumentsRequestSuccess = (data) => ({
	type: GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS,
	payload: data,
})

export const getViewerAllDocumentsRequestFailed = (data) => ({
	type: GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED,
	payload: data,
})

export const getViewerAllDocumentsRequestReset = () => ({
	type: GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET,
})

export const updateViewerPageNumber = (data) => ({
	type: UPDATE_VIEWER_PAGE_NUMBER,
	payload: data,
})

export const getAuditHistory = (data) => ({
	type: GET_AUDIT_HISTORY,
	payload: data,
})

export const getAuditHistorySuccess = (data) => ({
	type: GET_AUDIT_HISTORY_SUCCESS,
	payload: data,
})

export const getAuditHistoryFailed = (data) => ({
	type: GET_AUDIT_HISTORY_FAILED,
	payload: data,
})

export const getAnnotation = (data, isNativePDF) => ({
	type: GET_ANNOTATION,
	payload: { data, isNativePDF },
})

export const getAnnotationSuccess = (data, isNative) => ({
	type: GET_ANNOTATION_SUCCESS,
	payload: { data, isNative },
})

export const getAnnotationFailed = (data) => ({
	type: GET_ANNOTATION_FAILED,
	payload: data,
})

export const addAnnotation = (data) => ({
	type: ADD_ANNOTATION,
	payload: data,
})

export const addAnnotationSuccess = (data, isNative) => ({
	type: ADD_ANNOTATION_SUCCESS,
	payload: { data, isNative },
})

export const addAnnotationFailed = (data) => ({
	type: ADD_ANNOTATION_FAILED,
	payload: data,
})

export const deleteAnnotation = (data, isNative) => ({
	type: DELETE_ANNOTATION,
	payload: { data, isNative },
})

export const deleteAnnotationSuccess = (data, isNative) => ({
	type: DELETE_ANNOTATION_SUCCESS,
	payload: { data, isNative },
})

export const DELETE_ANNOTATION_FAILED = (data) => ({
	type: GET_ANNOTATION_FAILED,
	payload: data,
})

export const updateSkipCount = (data) => ({
	type: UPDATE_SKIP_COUNT,
	payload: data,
})

export const logAudit = (data) => ({
	type: LOG_AUDIT,
	payload: data,
})

export const zoomInImage = (data) => ({
	type: ZOOM_IN_IMAGE,
	payload: data,
})

export const zoomOutImage = (data) => ({
	type: ZOOM_OUT_IMAGE,
	payload: data,
})

export const getChat = (data) => ({
	type: GET_CHAT,
	payload: data,
})

export const getChatSuccess = (data) => ({
	type: GET_CHAT_SUCCESS,
	payload: data,
})

export const getChatFailed = (data) => ({
	type: GET_CHAT_FAILED,
	payload: data,
})

export const getChatReset = (data) => ({
	type: GET_CHAT_RESET,
	payload: data,
})

export const postChat = (data) => ({
	type: POST_CHAT,
	payload: data,
})

export const postChatSuccess = (data) => ({
	type: POST_CHAT_SUCCESS,
	payload: data,
})

export const postChatFailed = (data) => ({
	type: POST_CHAT_FAILED,
	payload: data,
})

export const updateCurrentSession = (session) => ({
	type: UPDATE_CURRENT_SESSION,
	payload: session,
})
export const RotateLeftImage = (data) => ({
	type: ROTATE_LEFT_IMAGE,
	payload: data,
})

export const RotateRightImage = (data) => ({
	type: ROTATE_RIGHT_IMAGE,
	payload: data,
})
